import { useCallback } from 'react'
import { usePreferencias } from './contexto-de-preferencias.tsx'
import type { Idioma, Traducao } from '../textos.ts'

export const TEXTOS_DO_SHELL = {
  abrirMenu: { 'pt-BR': 'Abrir menu', 'es-419': 'Abrir menú', 'en-US': 'Open menu' },
  retrairMenu: { 'pt-BR': 'Retrair menu', 'es-419': 'Contraer menú', 'en-US': 'Collapse menu' },
  fixarMenu: { 'pt-BR': 'Fixar menu aberto', 'es-419': 'Fijar menú abierto', 'en-US': 'Pin menu open' },
  busca: { 'pt-BR': 'Busca global', 'es-419': 'Búsqueda global', 'en-US': 'Global search' },
  exemploBusca: { 'pt-BR': 'Buscar empresas, negócios, pedidos…', 'es-419': 'Buscar empresas, negocios, pedidos…', 'en-US': 'Search companies, opportunities, orders…' },
  documentacao: { 'pt-BR': 'Documentação', 'es-419': 'Documentación', 'en-US': 'Documentation' },
  sair: { 'pt-BR': 'Sair', 'es-419': 'Salir', 'en-US': 'Sign out' },
  pular: { 'pt-BR': 'Pular para o conteúdo', 'es-419': 'Saltar al contenido', 'en-US': 'Skip to content' },
  notificacoes: { 'pt-BR': 'Notificações', 'es-419': 'Notificaciones', 'en-US': 'Notifications' },
  entidade: { 'pt-BR': 'Entidade', 'es-419': 'Entidad', 'en-US': 'Entity' },
  ambienteDeTestes: { 'pt-BR': 'ambiente de testes', 'es-419': 'entorno de pruebas', 'en-US': 'test environment' },
  consolidado: { 'pt-BR': 'consolidado', 'es-419': 'consolidado', 'en-US': 'consolidated' },
} as const satisfies Readonly<Record<string, Traducao>>

/** Somente os rótulos da navegação; rotas, módulos, grupos e nomes pessoais não mudam. */
const NOMES: Readonly<Record<string, Readonly<Record<Exclude<Idioma, 'pt-BR'>, string>>>> = {
  'Visão Geral': { 'es-419': 'Vista general', 'en-US': 'Overview' },
  Comercial: { 'es-419': 'Comercial', 'en-US': 'Sales' },
  Empresas: { 'es-419': 'Empresas', 'en-US': 'Companies' },
  Contatos: { 'es-419': 'Contactos', 'en-US': 'Contacts' },
  Negócios: { 'es-419': 'Negocios', 'en-US': 'Opportunities' },
  Metas: { 'es-419': 'Metas', 'en-US': 'Targets' },
  Previsão: { 'es-419': 'Previsión', 'en-US': 'Forecast' },
  Receita: { 'es-419': 'Ingresos', 'en-US': 'Revenue' },
  'Basquete (Pedidos)': { 'es-419': 'Basquete (Pedidos)', 'en-US': 'Basquete (Orders)' },
  'Faturamento & NFs': { 'es-419': 'Facturación y facturas fiscales', 'en-US': 'Invoicing & tax invoices' },
  'Recebíveis & Cobrança': { 'es-419': 'Cuentas por cobrar y cobranza', 'en-US': 'Receivables & collections' },
  Comissões: { 'es-419': 'Comisiones', 'en-US': 'Commissions' },
  'Operações de Mídia': { 'es-419': 'Operaciones de medios', 'en-US': 'Media operations' },
  Campanhas: { 'es-419': 'Campañas', 'en-US': 'Campaigns' },
  Financeiro: { 'es-419': 'Finanzas', 'en-US': 'Finance' },
  'Fluxo de Caixa': { 'es-419': 'Flujo de caja', 'en-US': 'Cash flow' },
  'Contas Bancárias': { 'es-419': 'Cuentas bancarias', 'en-US': 'Bank accounts' },
  Conciliação: { 'es-419': 'Conciliación', 'en-US': 'Reconciliation' },
  'Contas a Pagar': { 'es-419': 'Cuentas por pagar', 'en-US': 'Accounts payable' },
  Aprovações: { 'es-419': 'Aprobaciones', 'en-US': 'Approvals' },
  Fornecedores: { 'es-419': 'Proveedores', 'en-US': 'Suppliers' },
  Orçamento: { 'es-419': 'Presupuesto', 'en-US': 'Budget' },
  'Plano de Contas': { 'es-419': 'Plan de cuentas', 'en-US': 'Chart of accounts' },
  'Ativos intangíveis': { 'es-419': 'Activos intangibles', 'en-US': 'Intangible assets' },
  'DRE & Demonstrativos': { 'es-419': 'DRE y estados financieros', 'en-US': 'DRE & financial statements' },
  Relatórios: { 'es-419': 'Informes', 'en-US': 'Reports' },
  RH: { 'es-419': 'RR. HH.', 'en-US': 'HR' },
  Tarefas: { 'es-419': 'Tareas', 'en-US': 'Tasks' },
  Configurações: { 'es-419': 'Configuración', 'en-US': 'Settings' },
}

export function useRotuloDaNavegacao() {
  const { idioma } = usePreferencias()
  return useCallback((rotulo: string): string =>
    idioma === 'pt-BR' ? rotulo : NOMES[rotulo]?.[idioma] ?? rotulo, [idioma])
}
